// hooks/useApiURL.ts
import { useEffect, useState } from "react";

export function useApiURL() {
  const currentAPI = process.env.NEXT_PUBLIC_ERPAPI || ""; // fallback empty if undefined
  const [apiURL, setApiURL] = useState(currentAPI);

  useEffect(() => {
    const prodDomain = "www.vidyalayalms.com";
    const liveAPI = "https://erpnew.onlinevidyalaya.net";

    if (typeof window !== "undefined") {
      if (window.location.hostname === prodDomain) {
        setApiURL(liveAPI);
      } else {
        setApiURL(currentAPI);
      }
    }
  }, [currentAPI]);

  return apiURL;
}
